import { formattedDate, getDateTime, getShortDateDiff } from '~/src/Lib/Utils'

export const formatReading = dataToFormat => {
  const { annotation, entities } = dataToFormat
  const { dataTypes } = entities
  const { comments, value, dataTypeKey } = annotation
  const dataType = dataTypes?.[dataTypeKey]
  let body = value ? [dataType?.format?.(value), comments].filter(Boolean).join(' - ') || null : null
  let duration
  if (dataTypeKey === 'dryback') {
    const { start, end } = annotation
    const startDt = getDateTime(start)
    const endDt = getDateTime(end)
    duration = [
      formattedDate(startDt, endDt.hasSame(startDt, 'day') ? 'SHORT_TIME' : 'TINY_DATETIME'),
      formattedDate(endDt, 'TINY_DATETIME')
    ].join('\u00a0-\u00a0').replace(/( )(am|pm)/gi, '$2')
    body = body ? [
      `${dataType?.format?.(value)} (Duration: ${getShortDateDiff(startDt, endDt)})`,
      comments
    ].filter(Boolean).join(' - ') : null
  }

  return {
    title: dataType?.name || null,
    body,
    dataType,
    duration,
  }
}
